export type TodoType = 'CALL' | 'MEETING' | 'INTERNAL_TASK';
export type TimeType = 'DEADLINE' | 'EXACT_TIME' | 'INTERVAL';
export type CompletionType = 'EVERYONE' | 'ANYONE';

export const DAYS = Array.from({ length: 31 }, (_, i) => String(i + 1));

export const MONTHS = [
  'Januar',
  'Februar',
  'Mart',
  'April',
  'Maj',
  'Jun',
  'Jul',
  'Avgust',
  'Septembar',
  'Oktobar',
  'Novembar',
  'Decembar',
];

export const YEARS = Array.from({ length: 2 }, (_, i) => String(new Date().getFullYear() + i));

export const TYPE_MAP: Record<string, TodoType> = {
  Poziv: 'CALL',
  Sastanak: 'MEETING',
  'Interni zadatak': 'INTERNAL_TASK',
};

export const TIME_TYPE_MAP: Record<string, TimeType> = {
  deadline: 'DEADLINE',
  exact: 'EXACT_TIME',
  interval: 'INTERVAL',
};

export const COMPLETION_TYPE_MAP: Record<string, CompletionType> = {
  everyone: 'EVERYONE',
  anyone: 'ANYONE',
};

// Recurring type options (from BE)
export type RecurringType = 'DAILY' | 'WEEKLY' | 'MONTHLY';

export const RECURRING_TYPE_LABELS: Record<RecurringType, string> = {
  DAILY: 'Dnevno',
  WEEKLY: 'Nedeljno',
  MONTHLY: 'Mesečno',
};
